import { Component } from '@angular/core';

@Component({
    selector: 'force-reload-dialog',
    templateUrl: './force-reload-dialog.component.html',
    styleUrls: ['./force-reload-dialog.component.scss'],
})
export class ForceReloadDialogComponent {}
